module.exports = __webpack_public_path__ + "img/24.1c59f0a2.jpg";